import Act from '../actions';

const initState = {
	dbData: {
		initial: [],
		filter: [],
	},
	SNAData: {},
	legends: null,
	curNode: null,
	curPubData: null,
	regionList: [],
	countryList: [],
};

const snaReducer = (state = initState, action) => {
	switch (action.type) {
		case Act.SNA_INIT:
			return { ...initState };
		case Act.SNA_DB_DATA:
			return {
				...state,
				dbData: action.payload,
			};
		case Act.SNA_SNA_GRAPH_DATA:
			return {
				...state,
				SNAData: action.payload,
			};
		case Act.SNA_GRAPH_LEGENDS:
			return {
				...state,
				legends: action.payload,
			};
		case Act.SNA_CUR_NODE:
			return {
				...state,
				curNode: action.payload,
			};
		case Act.SNA_CUR_PUB_DATA:
			return {
				...state,
				curPubData: action.payload,
			};
		case Act.SNA_REGION_LIST:
			return {
				...state,
				regionList: action.payload,
			};
		case Act.SNA_COUNTRY_LIST:
			return {
				...state,
				countryList: action.payload,
			};
		default:
			return state;
	}
};

export default snaReducer;
